export default {
    checked: false,
    passed: false,
    formSubmitted: false,
    isModalOpen: false,
    modalTitle: '',
    modalBody: '',
};
